import React, { Component } from "react";


export default class Footer extends Component {

    render() {
        return (<div className="footer-middle pt-20 pb-5">
            <div className="container">

                <div className="row footer-bottom mt-50">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="footer-bottom-content">
                            <div className="footer-bottom-content-copy">
                                <p>
                                    © CiroTrx All Rights Reserved. By: <span>Brutus.finance Team</span><br />
                                    <a href={"https://tronscan.io/#/contract/TXSvbF6MSukLMrYiLA5PfLHaPh97up2aGm/code"} rel="noopener noreferrer" target="_blank">View Contract standard</a><br />

                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="footer-bottom-content">
                            <div className="footer-bottom-menu" style={{ textAlign: "center" }}>
                                <ul>
                                    <li><a href="?white-apaper">White Paper</a></li>
                                    <li><a href="?privacy-policy">Privacy Policy</a></li>
                                    <li><a href="?terms-and-conditions">Terms & Conditions</a></li>
                                    <li><a href="?dapp-pro">Pro for business</a></li>
                                    <li id="version">Version: 1.4.0 rev: 19/05/25 </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }
}
